import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-50 border-t border-gray-200 pt-16 pb-8" data-id="element-26">
      <div className="container mx-auto px-4 md:px-6" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-28">
          <div className="col-span-1 md:col-span-1" data-id="element-29">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-30">
              <div className="bg-[#6366F1] p-1.5 rounded-lg" data-id="element-31">
                <ShoppingCart className="h-5 w-5 text-white" data-id="element-32" />
              </div>
              <span className="text-lg font-bold text-gray-900" data-id="element-33">
                Cart Tracker
              </span>
            </Link>
            <p className="text-gray-600 text-sm mb-6" data-id="element-34">
              Capture cart information from any website and send it to your
              procurement system or finance team instantly.
            </p>
            <div className="flex gap-4" data-id="element-35">
              <a href="#" className="text-gray-400 hover:text-[#6366F1] transition-colors" data-id="element-36">
                <Twitter className="h-5 w-5" data-id="element-37" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#6366F1] transition-colors" data-id="element-38">
                <Linkedin className="h-5 w-5" data-id="element-39" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#6366F1] transition-colors" data-id="element-40">
                <Github className="h-5 w-5" data-id="element-41" />
              </a>
            </div>
          </div>

          <div data-id="element-42">
            <h4 className="font-semibold text-gray-900 mb-4" data-id="element-43">Product</h4>
            <ul className="space-y-3 text-sm text-gray-600" data-id="element-44">
              <li data-id="element-45">
                <Link to="/features" className="hover:text-[#6366F1]" data-id="element-46">
                  Features
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/how-it-works" className="hover:text-[#6366F1]" data-id="element-48">
                  How it Works
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/pricing" className="hover:text-[#6366F1]" data-id="element-50">
                  Pricing
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/integrations" className="hover:text-[#6366F1]" data-id="element-52">
                  Integrations
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-53">
            <h4 className="font-semibold text-gray-900 mb-4" data-id="element-54">Company</h4>
            <ul className="space-y-3 text-sm text-gray-600" data-id="element-55">
              <li data-id="element-56">
                <Link to="/case-study" className="hover:text-[#6366F1]" data-id="element-57">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/security" className="hover:text-[#6366F1]" data-id="element-59">
                  Security
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/privacy-policy" className="hover:text-[#6366F1]" data-id="element-61">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-[#6366F1]" data-id="element-63">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-64">
          <p className="text-sm text-gray-500" data-id="element-65">
            © {new Date().getFullYear()} Cart Tracker Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-66">
            <Link to="/security" className="hover:text-[#6366F1]" data-id="element-67">
              Security
            </Link>
            <Link to="/privacy-policy" className="hover:text-[#6366F1]" data-id="element-68">
              Privacy
            </Link>
            <a href="#" className="hover:text-[#6366F1]" data-id="element-69">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}